/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetXY = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetXY(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data for the data with XY data.
 * Expects new non-time valet data with one dimension - serial number of observations.
 * Replies on data-series0XField parameters
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetXY = function (data, dataLoader, chart) {
    var output,
        revisedText,
        seriesDetails,
        series,
        categorySet,
        category,
        seriesSet;

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running postProcessValetXY, inputs:",
            data,
            "Graphs: ",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    output = [];
    revisedText = bocAmchart.getRevisedText();

    // Find all the XFields series
    var xFields = [];
    for (var arg in chart.bocSettings.args) {
        var pattern = /series\dxfield/;
        if (chart.bocSettings.args.hasOwnProperty(arg) && pattern.test(arg)) {
            xFields.push(chart.bocSettings.args[arg]);
        }
    }

    // Setting "named array" to avoid multiple loops through data
    categorySet = [];
    seriesSet = [];

    var dimensions = [];
    var dimension;

    for (series in data.seriesDetail) {
        if (data.seriesDetail.hasOwnProperty(series)) {
            seriesDetails = data.seriesDetail[series];
            if (seriesDetails.hasOwnProperty("dimension") && seriesDetails.dimension.hasOwnProperty("key")) {
                if (dimensions.indexOf(seriesDetails.dimension.key) === -1) {
                    dimensions.push(seriesDetails.dimension.key);
                }
            }
        }
    }

    if (dimensions.length > 0) {
        dimension = dimensions[0];
        if (dimensions.length > 1) {
            // eslint-disable-next-line no-console
            console.warn("Data error, more than one dimension found.");
        }
    } else {
        // eslint-disable-next-line no-console
        console.warn("Data error, no dimensions found.");
    }

    // Loop through all the observations, get all the series
    // Later observations containing same series will overwrite previous data

    data.observations.forEach(function (obs) {

        // Set the category values based on dimension
        if (obs.hasOwnProperty(dimension)) {
            var category = obs[dimension];

            // Looping through series, and find an observation for each of them
            for (series in data.seriesDetail) {
                if (data.seriesDetail.hasOwnProperty(series) && obs.hasOwnProperty(series)) {

                    // Initialize the container for values of series for specific category
                    if (!categorySet.hasOwnProperty(category)) {
                        categorySet[category] = {};
                    }

                    // This value point belongs to series that has chosen dimension
                    if (seriesSet.indexOf(series) === -1) {
                        seriesSet.push(series);
                    }

                    categorySet[category][series] = obs[series].v;
                    if (obs[series].hasOwnProperty('r') && obs[series].r === 1) {
                        categorySet[category][series + '_R'] = revisedText;
                    }
                }
            }
        }
    });

    for (category in categorySet) {
        output.push(categorySet[category]);
    }

    // Add the column graph for each series term found
    chart.graphs = [];

    seriesSet.forEach(function (term) {
        if (xFields.indexOf(term) === -1) {
            bocAmchart.addGraph(chart, term, data.seriesDetail[term].label, 'scatter');
        }
    });

    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after postProcessValetXY:",
            output,
            "Graphs:",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    return output;
}
;
